import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { retrieveSpecificWorkQ } from "../../../lib/systemData";

import classes from './MegaMasterFilters.module.css'
import MegaMasterFiltersItem from "./specificFilters/MegaMasterFiltersItem";

export default function MegaMasterFilters({mainSelectAction, generalAsyncSearchFilter, filtersValues, workQ, payerTypeStatusAction, removepayerTypeStatus, practicePatientStatusAction}) {

    let { workqSlug } = useParams();  

    const [superFilters, setSuperFilters] = useState(null)



    useEffect(() => {

        if (workqSlug) {
            const foundworkq = workQ?.filter_groups ? workQ : retrieveSpecificWorkQ(workqSlug)

            if (foundworkq && foundworkq.filter_groups) {
                const filterGroups = [...foundworkq.filter_groups]
                const hasPracticePatientStatusFilter = filterGroups.some(
                    filter => filter.key == 'practice_patient_status_filters'
                )
                const shouldShowPracticePatientStatusFilter =
                    foundworkq.filter_conditions?.practice_patient_status_filters_filter_type == 2
                    || (filtersValues?.practice_patient_status_filters && filtersValues.practice_patient_status_filters.length)

                if (shouldShowPracticePatientStatusFilter && !hasPracticePatientStatusFilter) {
                    filterGroups.push({
                        group: 'Case Practice',
                        key: 'practice_patient_status_filters',
                        label: 'Practice Patient Status',
                    })
                }

                let groupNameArray = []
                filterGroups.forEach(element => {
                    if (!groupNameArray.includes(element.group)) {
                        groupNameArray.push(element.group)
                    }                    
                });

                let f = groupNameArray.map(item => {
                    return {
                        group : item,
                        filters: []
                    }
                })

                filterGroups.forEach(item => {

                    f.forEach(elem => {
                        if (elem.group == item.group) {
                            elem.filters.push({
                                key: item.key,
                                label: item.label
                            })
                        }
                    })
                })
                setSuperFilters(f)
            } else {
                setSuperFilters(null)
            }

            // // clear order filters when changeing workq 
            // dispatch(filterActions.setOrderFilters(null))
            // //return the page to the initial state == 1
            // dispatch(filterActions.setCurrentPage(1))
        }

        
    }, [workqSlug, workQ, filtersValues?.practice_patient_status_filters])

    return <>
        {superFilters && superFilters.map(item => (
            <MegaMasterFiltersItem key={item.group} classes={classes} item={item} mainSelectAction={mainSelectAction} generalAsyncSearchFilter={generalAsyncSearchFilter} filtersValues={filtersValues} workQ={workQ} payerTypeStatusAction={payerTypeStatusAction} removepayerTypeStatus={removepayerTypeStatus} practicePatientStatusAction={practicePatientStatusAction}/>
        ))}
    </>
}